import Http from '@/services/http';
import EditModuleInformationFieldsDefinitions from '@/domain/data/installation/supervision/sensors/editModuleInformationFieldsDefinitions';
import { ModuleInformationResponse, ModuleInformationRequest } from 'sigma-mappings';
import translate from '@/services/translate';

const urls = {
  getModuleInformation: assetModuleId => `/supervisao/${assetModuleId}/informacoes-modulos`,
  updateModuleInformation: (assetModuleId, id) => `/supervisao/${assetModuleId}/informacoes-modulos/${id}`,
};

const fieldLengths = {
  NomeExibicao: {
    min: '2',
    max: '250',
  },
  Endereco: {
    min: '12',
    max: '1000',
  },
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA001: (data) => {
        const returnedField = EditModuleInformationFieldsDefinitions[data.field];
        if (!returnedField) return null;

        return {
          NomeDoCampo: translate(returnedField.label),
        };
      },
      $MA051: data => {
        const returnedField = EditModuleInformationFieldsDefinitions[data.field];
        return {
          maxLength: data.parameters[0],
          fieldName: translate(returnedField.label),
        };
      },
      $MG001: data => {
        const returnedField = EditModuleInformationFieldsDefinitions[data.field];
        const parameters = data.parameters || {};
        const lengths = fieldLengths[data.field] || {};
        return {
          0: parameters[0] || lengths.min,
          1: parameters[1] || lengths.max,
          fieldName: translate(returnedField.label),
        };
      },
    },
  },
};

export default {
  getModuleInformation(assetModuleId) {
    return new Http()
      .get(urls.getModuleInformation(assetModuleId))
      .then(({ data }) => {
        const mappedResponse = data.enderecos.map(
          item => new ModuleInformationResponse(item),
        );
        return mappedResponse;
      });
  },

  updateModuleInformation(payload) {
    const mappedPayload = new ModuleInformationRequest(payload);
    return new Http(error).put(
      urls.updateModuleInformation(payload.assetModuleId, payload.id),
      mappedPayload,
    );
  },
};
